<div class="row">
	<div [ngClass]="activityPanelOpen ? 'col-lg-9' : 'col-lg-12'">
		<!-- main lead content -->
		<div class="card">
			<div class="card-body">
				<div *ngIf="leadLoading">
					<app-loading></app-loading>
				</div>
				<div class="row" *ngIf="!leadLoading && !lead">
					<div class="col-md-12 ml-auto mr-auto mb-2">
						<h4 class="text-danger"><i class="em em-warning"></i> {{ leadMsg }}</h4>
					</div>
				</div>
				<div class="row" *ngIf="!leadLoading && lead">
					<div class="col-md-12">
						<div class="row">
							<div class="col-12">
								<h4 style="position: relative; top: 20px; margin-top: 0px">Lead #{{ leadId }}</h4>
							</div>
						</div>
						<div class="row mt-4">
							<div class="col-md-10">
								<h2 class="campaign-row-title" style="margin-top: 0px">
									<small>
										<span
											class="badge"
											[ngClass]="{
												'bg-success': lead.lead_status == 'Approved',
												'bg-danger': lead.lead_status == 'Denied',
												'bg-info': lead.lead_status == 'Unreviewed',
												'bg-warning': lead.lead_status == 'Fix'
											}"
										>
											<span>{{ lead.lead_status }}</span>
										</span>
										{{ lead.prospect_company }} - {{ lead.campaign_name }}
									</small>
								</h2>
								<p *ngIf="lead.replacement_status != 'N/A' && lead.replacement_status != ''">
									Replacement or reschedule status:
									<span
										class="badge"
										[ngClass]="{
											'bg-danger': lead.replacement_status === 'Denied Reschedule',
											'bg-info': lead.replacement_status === 'Pending Reschedule' || lead.replacement_status === 'Rescheduled' || lead.replacement_status === 'Pending Replacement' || lead.replacement_status === 'Replaced',
											'bg-warning': lead.replacement_status === 'QC Calls' || lead.replacement_status === 'Reschedule Request'
										}"
									>
										{{ lead.replacement_status }}
									</span>
								</p>
								<p *ngIf="lead.customer_received === 'F'">The client hasn't confirmed receipt of the lead.</p>
								<p *ngIf="lead.customer_received === 'T'">The client confirmed receipt of the lead on {{ lead.received_date | utcToLocal : "longDate" }}</p>
							</div>
							<div class="col-md-2 d-flex gap-2 align-items-start">
								<button class="btn btn-primary bg-primary" (click)="resendEmail()"><i class="ri-mail-line"></i> Resend Email</button>
								<button class="btn btn-outline-secondary" (click)="activityPanelOpen = !activityPanelOpen" title="Toggle activity panel">
									<i [class]="activityPanelOpen ? 'ri-layout-right-2-line' : 'ri-layout-right-line'"></i>
								</button>
							</div>
						</div>
					</div>
					<div class="row">&nbsp;</div>
					<ul class="nav nav-tabs mb-3" role="tablist" *ngIf="!leadLoading && lead">
						<li class="nav-item" role="presentation">
							<a class="nav-link" data-bs-toggle="tab" [ngClass]="{ active: activeTab === 'details' }" role="tab" aria-selected="false" tabindex="-1" (click)="activeTab = 'details'">Details</a>
						</li>
						<li class="nav-item" role="presentation">
							<a class="nav-link" data-bs-toggle="tab" [ngClass]="{ active: activeTab === 'call_sheet' }" role="tab" aria-selected="false" tabindex="-1" (click)="getCallSheet()">Call Sheet</a>
						</li>
						<li class="nav-item" role="presentation">
							<a class="nav-link" data-bs-toggle="tab" [ngClass]="{ active: activeTab === 'lead_log' }" role="tab" aria-selected="false" tabindex="-1" (click)="activeTab = 'lead_log'"
								>Leads <span class="badge bg-warning" *ngIf="leadDispos.length > 0">{{ leadDispos.length }}</span></a
							>
						</li>
						<li class="nav-item" role="presentation">
							<a class="nav-link" data-bs-toggle="tab" [ngClass]="{ active: activeTab === 'qc_notes' }" role="tab" aria-selected="false" tabindex="-1" (click)="goToQcNotes()">QC Notes</a>
						</li>
						<li class="nav-item" role="presentation">
							<a class="nav-link" data-bs-toggle="tab" [ngClass]="{ active: activeTab === 'history' }" (click)="goToHistory()" role="tab" aria-selected="false" tabindex="-1">History</a>
						</li>

						<li class="nav-item" role="presentation">
							<a class="nav-link" data-bs-toggle="tab" [ngClass]="{ active: activeTab === 'attachments' }" role="tab" aria-selected="false" tabindex="-1" (click)="getLeadFiles('attachments')">Attachments</a>
						</li>
					</ul>
					<div *ngIf="!leadLoading && lead" class="row">
						<ng-container *ngIf="activeTab === 'details'">
							<div *ngIf="leadLoading" class="text-center">
								<app-loading></app-loading>
							</div>
							<div class="col-md-12 ml-auto mr-auto">
								<h3 class="text-danger">{{ leadMsg }}</h3>
							</div>
							<div class="col-md-12 ml-auto mr-auto text-right">
								<div class="row">
									<div class="col-md-3 mb-3">
										<label class="float-left">Assigned To: {{ lead.campaign_id }}</label>
										<select class="form-control appt-select" [(ngModel)]="lead.campaign_id" #campaign_id="ngModel" ngControl="campaign_id" name="campaign_id">
											<option *ngFor="let campaign of activeCampaigns; let i = index" value="{{ campaign.id }}">{{ campaign.name }}</option>
										</select>
									</div>
									<!-- Admin buttons -->
									<div class="col-md-9 mb-3">
										<label style="height: 1.3em">Changes will save clicking back button</label>
										<div class="row">
											<div class="col-md-12 col-mb-3 d-flex flex-wrap gap-2">
												<button class="btn btn-primary btn-xsm" (click)="openCalendar(lead.campaign_id, lead.alias)"><i class="ri-calendar-line"></i> Calendar</button>
												<button class="btn btn-danger btn-xsm" (click)="open(adminRescheduleModal)" *ngIf="lead.replacement_status != 'Reschedule Request' && lead.replacement_status != 'Customer Action' && lead.replacement_status != 'Replacement Request'"><i class="ri-calendar-line"></i> Reschedule</button>
												<div ngbDropdown class="d-inline-block" *ngIf="lead.replacement_status != 'Reschedule Request' && lead.replacement_status != 'Replacement Request'">
													<button class="btn btn-success" ngbDropdownToggle>Approve or Deny</button>
													<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
														<button class="dropdown-item bg-success" (click)="approveLeadById(lead)">Approve</button>
														<button class="dropdown-item bg-danger" (click)="denyLead(lead)">Deny</button>
														<button class="dropdown-item bg-warning" (click)="fixLeadById(lead)">Fix</button>
													</div>
												</div>

												<button class="btn btn-primary bg-primary" *ngIf="lead.replacement_status != 'Reschedule Request' && lead.replacement_status != 'Replacement Request'" (click)="sendSurvey()"><i class="ri-mail-line"></i> Send Survey</button>

												<button class="btn btn-dark" *ngIf="lead.replacement_status != 'Reschedule Request' && lead.replacement_status != 'Replacement Request'" (click)="sendCalendarInvite()"><i class="ri-mail-line"></i> Calendar Invite</button>

												<button class="btn btn-warning bg-orange" *ngIf="lead.replacement_status === 'Reschedule Request'" (click)="confirmRescheduleFree()">Approve Reschedule for Free</button>
												<button class="btn btn-warning bg-orange" *ngIf="lead.replacement_status === 'Reschedule Request'" (click)="confirmRescheduleCharge()">Approve Reschedule with Fee</button>
												<button class="btn btn-danger bg-red" *ngIf="lead.replacement_status === 'Reschedule Request'" (click)="denyReschedule()">Deny Reschedule</button>
												<button class="btn btn-warning bg-orange" *ngIf="lead.replacement_status === 'Replacement Request'" (click)="confirmReplacementFree()">Approve Replacement for Free</button>
												<button class="btn btn-warning bg-orange" *ngIf="lead.replacement_status === 'Replacement Request'" (click)="confirmReplacementCharge()">Approve Replacement with Fee</button>
												<button class="btn btn-danger bg-red" *ngIf="lead.replacement_status === 'Replacement Request'" (click)="denyReplacement()">Deny Replacement</button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-12 ml-auto mr-auto">
								<div class="row">
									<div class="col-md-5 col-sm-6">
										<div class="form-group">
											<label>Company Name</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-building-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.prospect_company" #prospect_company="ngModel" ngControl="prospect_company" name="prospect_company" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-2 mb-3">
										<label class="float-left">Primary Phone</label>
										<p style="font-size: 15px; font-weight: 800">
											<a href="tel:+1{{ lead.primary_phone }}" ngbTooltip="Click To Call"> <i class="ri-phone-fill"></i> {{ lead.primary_phone | phone }} </a>
										</p>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label><i class="em em-spiral_calendar_pad mr-2"></i>Appt Date</label>
											<input [(ngModel)]="lead.start_date" #start_date="ngModel" ngControl="start_date" name="start_date" class="form-control border-input" placeholder="Start Date" type="date" disabled />
										</div>
									</div>
									<div class="col-md-2 col-sm-3">
										<div class="form-group">
											<label class="float-left"><i class="em em-clock1 mr-2"></i>Appt Time</label>
											<input type="text" value="{{ Time24To12(lead.start_date, lead.start_time) }}" class="form-control" disabled />
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>First Name</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-user-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.first_name" #first_name="ngModel" ngControl="first_name" name="first_name" class="form-control border-input" placeholder="First Name" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>Last Name</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-user-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.last_name" #last_name="ngModel" ngControl="last_name" name="last_name" class="form-control border-input" placeholder="Last Name" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>Title</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-folder-user-fill"></i>
													</span>
												</div>
												<select class="form-control" [(ngModel)]="lead.title" #title="ngModel" ngControl="title" name="title">
													<option *ngFor="let title of titles" [value]="title">
														{{ title }}
													</option>
												</select>
											</div>
										</div>
									</div>
								</div>

								<div class="row mt-4">
									<div class="col-5">
										<label>Alternate Contact</label>
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text">
													<i class="ri-user-fill"></i>
												</span>
											</div>
											<input [(ngModel)]="lead.alt_contact" #last_name="ngModel" ngControl="last_name" name="last_name" class="form-control border-input" placeholder="Name Alternate contact" type="text" />
										</div>
									</div>
									<div class="col-3">
										<div class="form-group">
											<label>Alt Phone</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-phone-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.alt_phone" #alt_phone="ngModel" ngControl="alt_phone" name="alt_phone" class="form-control border-input" type="text" maxlength="10" />
											</div>
										</div>
									</div>
									<div class="col-4">
										<div class="form-group">
											<label>EIN</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-folder-user-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.ein" #ein="ngModel" ngControl="alt_phone" name="alt_phone" class="form-control border-input" type="text" maxlength="100" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4">
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>Address 1</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.address_1" #address_1="ngModel" ngControl="address_1" name="address_1" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>Address 2</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.address_2" #address_2="ngModel" ngControl="address_2" name="address_2" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>

									<div class="col-md-4 col-sm-4">
										<label>5500 Form</label>
										<div class="input-group mb-3">
											<input [(ngModel)]="lead.form_5500" type="text" #form_5500="ngModel" class="form-control" placeholder="5500 Form" aria-describedby="button-addon2" name="form_5500" />
											<div class="input-group-append">
												<a href="{{ lead.form_5500 }}" class="btn btn-secondary" target="_blank"><i class="ri-share-forward-fill"></i></a>
											</div>
										</div>
									</div>
								</div>

								<div class="row mt-4">
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>State</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.state" #state="ngModel" ngControl="state" name="state" class="form-control border-input" type="text" maxlength="2" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Zip</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.zip" #zip="ngModel" ngControl="zip" name="zip" class="form-control border-input" type="text" maxlength="6" />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>City</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.city" #city="ngModel" ngControl="city" name="city" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-5 col-sm-5">
										<div class="form-group">
											<label>Additional Info</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-asterisk"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.additional_info" #additional_info="ngModel" ngControl="additional_info" name="additional_info" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4"></div>
							</div>
							<div class="col-md-12 ml-auto mr-auto">
								<div class="row mt-4">
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Direct Line</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-phone-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.direct_line" #direct_line="ngModel" ngControl="direct_line" name="direct_line" class="form-control border-input" placeholder="Direct Line" type="text" maxlength="10" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Mobile Phone</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-smartphone-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.mobile_phone" #mobile_phone="ngModel" ngControl="mobile_phone" name="mobile_phone" class="form-control border-input" placeholder="Mobile" type="text" maxlength="10" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Extension</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-phone-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.ext" #ext="ngModel" ngControl="ext" name="ext" class="form-control border-input" placeholder="Extension" type="text" maxlength="10" />
											</div>
										</div>
									</div>
									<div class="col-md-6 col-sm-6">
										<div class="form-group">
											<label>Website</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-macbook-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.website_url" #website_url="ngModel" ngControl="website_url" name="website_url" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4">
									<div class="col-md-6 col-sm-6">
										<div class="form-group">
											<label>Primary Email</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-mail-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.email" #email="ngModel" ngControl="email" name="email" class="form-control border-input" placeholder="Primary Email" type="email" />
											</div>
										</div>
									</div>
									<div class="col-md-6 col-sm-6">
										<div class="form-group">
											<label>Alt Email</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-mail-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.alt_email" #alt_email="ngModel" ngControl="alt_email" name="alt_email" class="form-control border-input" type="email" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4">
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Employee Size</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-team-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.employee_size" #employee_size="ngModel" ngControl="employee_size" name="employee_size" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Annual Revenue</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-money-dollar-box-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.annual_revenue" #annual_revenue="ngModel" ngControl="annual_revenue" name="annual_revenue" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Plan Asset Size</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-money-dollar-box-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.plan_assets" #plan_assets="ngModel" ngControl="plan_assets" name="plan_assets" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Plan Participants</label>

											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-team-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.plan_participants" #plan_participants="ngModel" ngControl="plan_participants" name="plan_participants" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4"></div>
								<div class="row mt-4">
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Provider/Carrier 1</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-bank-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.provider_1" #provider_1="ngModel" ngControl="provider_1" name="provider_1" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Renewal Month</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-calendar-line"></i>
													</span>
												</div>
												<select [(ngModel)]="lead.renewal_month_1" #renewal_month_1="ngModel" ngControl="renewal_month_1" name="renewal_month_1" class="form-control">
													<option value="0">NA</option>
													<option value="1">Jan</option>
													<option value="2">Feb</option>
													<option value="3">Mar</option>
													<option value="4">Apr</option>
													<option value="5">May</option>
													<option value="6">Jun</option>
													<option value="7">Jul</option>
													<option value="8">Aug</option>
													<option value="9">Sep</option>
													<option value="10">Oct</option>
													<option value="11">Nov</option>
													<option value="12">Dec</option>
												</select>
											</div>
										</div>
									</div>
									<div class="col-md-1 col-sm-1">
										<div class="form-group">
											<label>Year</label>
											<div class="input-group">
												<select [(ngModel)]="lead.renewal_year_1" #renewal_year_1="ngModel" ngControl="renewal_year_1" name="renewal_year_1" class="form-control">
													<option value="0">NA</option>
													<option value="2019">19</option>
													<option value="2020">20</option>
													<option value="2021">21</option>
													<option value="2022">22</option>
													<option value="2023">23</option>
													<option value="2024">24</option>
													<option value="2025">25</option>
													<option value="2026">26</option>
													<option value="2027">27</option>
													<option value="2028">28</option>
													<option value="2029">29</option>
													<option value="2030">30</option>
													<option value="2031">31</option>
												</select>
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Provider/Carrier 2</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-bank-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.provider_2" #provider_2="ngModel" ngControl="provider_2" name="provider_2" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Renewal Month</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-calendar-line"></i>
													</span>
												</div>
												<select [(ngModel)]="lead.renewal_month_2" #renewal_month_2="ngModel" ngControl="renewal_month_2" name="renewal_month_2" class="form-control">
													<option value="0">NA</option>
													<option value="1">Jan</option>
													<option value="2">Feb</option>
													<option value="3">Mar</option>
													<option value="4">Apr</option>
													<option value="5">May</option>
													<option value="6">Jun</option>
													<option value="7">Jul</option>
													<option value="8">Aug</option>
													<option value="9">Sep</option>
													<option value="10">Oct</option>
													<option value="11">Nov</option>
													<option value="12">Dec</option>
												</select>
											</div>
										</div>
									</div>
									<div class="col-md-1 col-sm-1">
										<div class="form-group">
											<label>Year</label>
											<div class="input-group">
												<select [(ngModel)]="lead.renewal_year_2" #renewal_year_2="ngModel" ngControl="renewal_year_2" name="renewal_year_2" class="form-control">
													<option value="0">NA</option>
													<option value="2019">19</option>
													<option value="2020">20</option>
													<option value="2021">21</option>
													<option value="2022">22</option>
													<option value="2023">23</option>
													<option value="2024">24</option>
													<option value="2025">25</option>
													<option value="2026">26</option>
													<option value="2027">27</option>
													<option value="2028">28</option>
													<option value="2029">29</option>
													<option value="2030">30</option>
													<option value="2031">31</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row mt-4">
								<div class="col-12" align="right">
									<button class="btn btn-primary" (click)="saveLead()">Save</button>
								</div>
							</div>
							<div class="col-md-12 col-sm-12">
								<!-- LABEL AND BUTTON COPY -->
								<div class="row mt-4" style="margin-bottom: 5px">
									<div class="col-6">
										<label style="display: inline-block">Lead Notes - User => {{ lead.generated_by }}</label>
									</div>
									<div class="col-6" align="right">
										<button class="btn btn-info btn-sm" style="display: inline-block" (click)="copyMessage(lead.notes)">Click to copy <i class="fa fa-files-o" aria-hidden="true"></i></button>
									</div>
								</div>

								<div class="row">
									<div class="col-12">
										<div class="form-group">
											<textarea [(ngModel)]="lead.notes" #notes ngControl="notes" value="Si se copio" name="notes" class="form-control money-green notes-box" rows="5" placeholder="Enter Notes Here..." disabled *ngIf="user.isClient != 1"></textarea>
										</div>
									</div>
								</div>

								<div *ngIf="notes.length == 0 || notes == null || notes == undefined">There is no notes</div>
							</div>

							<div class="col-md-12 col-sm-12" *ngIf="lead.comments_request != ''">
								<div class="row">
									<div class="col-12">
										<p>Comments request</p>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group">
											<textarea style="background-color: beige" [(ngModel)]="lead.comments_request" #notes ngControl="notes" value="Si se copio" name="notes" class="form-control notes-box" rows="5" placeholder="Enter Notes Here..." disabled></textarea>
										</div>
									</div>
								</div>
							</div>

							<div class="col-md-12 col-sm-12" style="cursor: pointer" (click)="reschedule_reason_display ? (reschedule_reason_display = false) : (reschedule_reason_display = true)">
								<span>Reschedule reason</span>
								<span><i class="fa" aria-hidden="true" [ngClass]="reschedule_reason_display ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
								<hr />
							</div>
							<div class="col-md-12 col-sm-12" *ngIf="reschedule_reason_display">
								<div class="form-group">
									<textarea [(ngModel)]="lead.reschedule_reason" #notes="ngModel" ngControl="notes" name="notes" class="form-control light-gray notes-box" rows="5" placeholder="Reschedule Reason" disabled></textarea>
								</div>
							</div>

							<div class="col-md-12 col-sm-12" style="cursor: pointer" (click)="client_feedback_display ? (client_feedback_display = false) : (client_feedback_display = true)">
								<span>Client Feedback</span>
								<span><i class="fa" aria-hidden="true" [ngClass]="client_feedback_display ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
								<hr />
							</div>
							<div class="col-md-12 col-sm-12" *ngIf="client_feedback_display">
								<div class="form-group">
									<textarea [(ngModel)]="lead.client_feedback" #notes="ngModel" ngControl="notes" name="notes" class="form-control light-yellow notes-box" rows="5" placeholder="Reschedule Reason" disabled></textarea>
								</div>
							</div>
							<div class="col-md-12 col-sm-12" style="cursor: pointer" (click)="client_notes_display ? (client_notes_display = false) : (client_notes_display = true)">
								<span>Client notes</span>
								<span><i class="fa" aria-hidden="true" [ngClass]="client_notes_display ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
								<hr />
							</div>
							<div class="col-md-12 col-sm-12" *ngIf="client_notes_display">
								<!-- <div class="form-group" >
									<textarea
										[(ngModel)]="lead.write_client_notes"
										#notes="ngModel"
										ngControl="notes"
										name="notes"
										class="form-control light-blue notes-box"
										rows="5"
										placeholder="There isn't client notes"
										disabled
									></textarea>
								</div> -->
								<ngx-simplebar class="px-3 mx-n3 mb-2" *ngFor="let item of client_notes">
									<div class="d-flex mb-4">
										<div *ngIf="item.client == 1" class="flex-grow-1 ms-3">
											<h5 class="fs-13">
												<img src="assets/images/users/avatar-c.png" alt="" class="avatar-xs rounded-circle" />
												Client comment<small class="text-muted">| {{ item.date }}</small>
											</h5>
											<p class="text-muted">{{ item.note }}</p>
											<!-- <a href="javascript: void(0);" class="badge text-muted bg-light"><i class="mdi mdi-reply"></i> Reply</a> -->
										</div>
										<div *ngIf="item.client == 0" class="flex-grow-1 ms-3">
											<h5 class="fs-13">
												<img src="assets/images/users/avatar-qc.png" alt="" class="avatar-xs rounded-circle" />
												QC response <small class="text-muted"> | {{ item.date }}</small>
											</h5>
											<p class="text-muted">{{ item.note }}</p>
											<!-- <a href="javascript: void(0);" class="badge text-muted bg-light"><i class="mdi mdi-reply"></i> Reply</a> -->
										</div>
									</div>
								</ngx-simplebar>

								<div class="mt-4 col-lg-10" *ngIf="messageSuccess != ''">
									<app-success-msg [msg]="messageSuccess"></app-success-msg>
								</div>

								<form (ngSubmit)="submitNotes()" class="mt-4">
									<div class="row g-3">
										<div class="col-lg-12">
											<label for="exampleFormControlTextarea1" class="form-label">Reply Notes</label>
											<textarea class="form-control bg-light border-light" name="client_notes_area" id="client_notes_area" [(ngModel)]="formData.client_notes_area" rows="3" rows="5" placeholder="Write your answer ..."></textarea>
										</div>
										<div class="col-12 text-end">
											<button class="btn btn-success" type="submit">
												<i *ngIf="loadingSaveNote == false" class="bx bx-save align-bottom me-1"></i>
												<div *ngIf="loadingSaveNote" class="spinner-border spinner-border-sm text-light" role="status">
													<span class="sr-only">Loading...</span>
												</div>
												Save Response
											</button>
										</div>
									</div>
								</form>
							</div>
						</ng-container>

						<ng-container *ngIf="activeTab === 'lead_log'">
							<div class="col-md-12 ml-auto mr-auto" *ngIf="leadDispos && leadDispos.length">
								<h3 class="company-title">{{ leadDispos.length }} LEADS(s) Total</h3>
								<p>&nbsp;</p>
							</div>
							<ng-container *ngIf="leadDispos && leadDispos.length">
								<div class="col-md-12 ml-auto mr-auto" *ngFor="let dispo of leadDispos; let i = index" [attr.data-index]="i">
									<div class="card-body comment">
										<h6 class="card-title">
											<span class="dispo-log-code text-danger">{{ dispo.dispo }}</span> - {{ dispo.campaign_name }} - {{ dispo.user_login }} -
											<span class="text-danger">{{ dispo.date | utcToLocal : "medium" }}</span>
										</h6>
										<p class="card-text dispo-text-blue">{{ dispo.notes }}</p>
										<span class="dispo-like">0 <i ngbTooltip="Coming Soon..." class="fa fa-thumbs-o-up" style="cursor: pointer"></i></span>
										<span class="dispo-unlike">0 <i ngbTooltip="Coming Soon..." class="fa fa-thumbs-o-down" style="cursor: pointer"></i></span>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="!leadDispos || !leadDispos.length">
								<div class="no-dispos"><i class="em em-warning mr-2"></i>No leads yet for this record.</div>
							</ng-container>
						</ng-container>

						<ng-container *ngIf="activeTab === 'qc_notes'">
							<div class="container">
								<br />
								<div class="row">
									<div class="col-md-2 col-sm-2" align="center">
										<label>Confirm Button</label><br />
										<button *ngIf="lead.confirmation != 'T'" class="btn btn-primary" (click)="confirmLead()">Confirm</button>
										<button *ngIf="lead.confirmation === 'T'" class="btn btn-primary">Confirmed</button>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Confirmation Date</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-calendar-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.confirmation_date" name="confrimation_date" class="form-control border-input" placeholder="Confirmation Date" type="text" disabled />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Confirmated By</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-user-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.confirmed_by" name="confirmed_by" class="form-control border-input" placeholder="Confirmed by" type="text" disabled />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2" align="center">
										<label for="">Difficulty: {{ lead.difficult }}</label>
										<br />
										<div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic" [(ngModel)]="lead.difficult">
											<label ngbButtonLabel class="btn-outline-danger"> <input ngbButton type="radio" value="Hard" /><i class="fa fa-flag" aria-hidden="true"></i> </label>
											<label ngbButtonLabel class="btn-outline-warning"> <input ngbButton type="radio" value="Medium" /><i class="fa fa-flag" aria-hidden="true"></i> </label>
											<label ngbButtonLabel class="btn-outline-success"> <input ngbButton type="radio" value="Easy" /><i class="fa fa-flag" aria-hidden="true"></i> </label>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Confirmation Voice Mail Date</label>

											<div class="form-group">
												<div class="input-group" style="border-radius: 5px 5px 5px 5px">
													<input id="date1" (click)="a.toggle()" class="form-control fomr-control-sm" placeholder="Confirmation Voice Mail Date" name="confirmation_voicemail_date" [(ngModel)]="lead.confirmation_voicemail_date" ngbDatepicker #a="ngbDatepicker" autocomplete="off" />
													<div class="input-group-append">
														<button class="btn btn-secondary btn-sm" (click)="a.toggle()" type="button" style="margin-right: 0px !important">
															<i class="ri-calendar-line"></i>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Contacted Prospect</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-folder-user-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.contacted_prospect" name="contacted_prospect" class="form-control border-input" placeholder="First Name" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Date contacted</label>
											<div class="input-group" style="border-radius: 5px 5px 5px 5px">
												<input id="date2" (click)="b.toggle()" class="form-control fomr-control-sm" placeholder="Date Contacted" name="contacted_date" [(ngModel)]="lead.contacted_date" ngbDatepicker #b="ngbDatepicker" autocomplete="false" />
												<div class="input-group-append">
													<button class="btn btn-secondary btn-sm" (click)="b.toggle()" type="button" style="margin-right: 0px !important">
														<i class="ri-calendar-line"></i>
													</button>
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<label for="">Audio Url</label>
										<div class="input-group mb-3">
											<input [(ngModel)]="lead.audio_url" type="text" class="form-control" placeholder="Aircall Audio URL" />
											<div class="input-group-append">
												<a href="{{ lead.audio_url }}" class="btn btn-secondary" target="_blank"><i class="ri-share-forward-fill"></i></a>
											</div>
										</div>
									</div>

									<div class="col-md-5 col-sm-5" align="left">
										<label for="">Ring central audio</label><br />
										<audio id="video" preload="metadata" controls name="media" class="audio-player" height="40">
											<source src="{{ audioUrl2 }}" type="audio/mp3" />
										</audio>
									</div>
								</div>

								<div class="row">
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Amount $</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-money-dollar-box-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.amount" name="amount" class="form-control border-input" placeholder="0.00" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Date Charged</label>
											<div class="input-group" style="border-radius: 5px 5px 5px 5px">
												<input id="date4" (click)="d.toggle()" class="form-control fomr-control-sm" placeholder="Date Charged" name="date_charged" [(ngModel)]="lead.date_charged" ngbDatepicker #d="ngbDatepicker" autocomplete="false" />
												<div class="input-group-append">
													<button class="btn btn-secondary btn-sm" (click)="d.toggle()" type="button" style="margin-right: 0px !important">
														<i class="ri-calendar-line"></i>
													</button>
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Employee Points</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-line-chart-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.employee_points" name="employee_points" class="form-control border-input" placeholder="Employee Points" type="text" />
											</div>
										</div>
									</div>

									<div class="col-md-3 col-sm-3">
										<label for="">Confirmation Status</label>
										<div class="input-group mb-3">
											<div class="input-group-prepend">
												<label class="input-group-text" for="inputGroupSelect01" style="margin-bottom: 0px !important"><i class="ri-checkbox-fill"></i></label>
											</div>
											<select [(ngModel)]="lead.confirmation_status" class="custom-select" id="inputGroupSelect01">
												<option selected>Choose...</option>
												<option value="1">One</option>
												<option value="2">Two</option>
												<option value="3">Three</option>
											</select>
										</div>
									</div>
									`
								</div>

								<div class="row">
									<div class="col-md-12">
										<label class="call-sheet-title">Replacement Options:</label>
									</div>
								</div>
								<div class="row">
									<div class="col-md-2" align="center">
										<button *ngIf="lead.replacement_status != 'QC Calls'" class="btn btn-primary" (click)="setReplacementStatus('QC Calls')" style="margin-top: 25px">QC Calls</button>
										<button *ngIf="lead.replacement_status == 'QC Calls'" class="btn btn-primary" (click)="setReplacementStatus('N/A')" style="margin-top: 25px">Undo QC Calls</button>
									</div>
									<div class="col-md-2" align="center">
										<button *ngIf="lead.replacement_status != 'Pending Replacement'" class="btn btn-primary" (click)="setReplacementStatus('Pending Replacement')" style="margin-top: 25px">Pending Replacement</button>
										<button *ngIf="lead.replacement_status == 'Pending Replacement'" class="btn btn-primary" (click)="setReplacementStatus('N/A')" style="margin-top: 25px">Undo Pending Replacement</button>
									</div>
									<div class="col-md-2" align="center">
										<button class="btn btn-dark" (click)="setReplacementStatus('Pending Reschedule')" style="margin-top: 25px" *ngIf="lead.replacement_status != 'Pending Reschedule'">Pending Reschedule</button>
										<div ngbDropdown class="d-inline-block">
											<button class="btn btn-secondary" *ngIf="lead.replacement_status == 'Pending Reschedule'" style="margin-top: 25px" ngbDropdownToggle>Reschedule Options</button>
											<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
												<button class="dropdown-item bg-danger" (click)="setReplacementStatus('Denied Reschedule')">Deny Pending Reschedule</button>
												<button class="dropdown-item bg-secondary" (click)="setReplacementStatus('N/A')">Undo Pending Reschedule</button>
											</div>
										</div>
									</div>

									<div class="col-md-3">
										<label>Click on button to select a replacement lead</label>
										<div class="input-group mb-3">
											<div class="input-group-append">
												<button class="btn btn-primary" (click)="openReplaceModal(replaceModal)">
													<i class="ri-arrow-left-right-line"></i>
												</button>
											</div>
											<input type="text" class="form-control" [(ngModel)]="lead.replaced_by" />
										</div>
									</div>

									<div class="col-md-3">
										<div class="form-group">
											<label>Date of Replaced</label>
											<div class="input-group" style="border-radius: 5px 5px 5px 5px">
												<input id="date3" (click)="c.toggle()" class="form-control fomr-control-sm" placeholder="Date Replaced" name="remplaced_date" [(ngModel)]="lead.remplaced_date" ngbDatepicker #c="ngbDatepicker" autocomplete="false" disabled />
												<div class="input-group-append">
													<button class="btn btn-secondary btn-sm" (click)="c.toggle()" type="button" style="margin-right: 0px !important" disabled>
														<i class="ri-calendar-line"></i>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-md-12 ml-auto mr-auto">
										<label class="call-sheet-title">QC Notes:</label>
										<textarea rows="2" cols="152" [(ngModel)]="lead.new_qc_notes" class="form-control border-input textArea-orange" type="text" placeholder="Add a new note ..."></textarea>
										<br />
									</div>
								</div>

								<div class="row">
									<div class="col-md-12 col-sm-12">
										<div *ngIf="notes_qc.length > 0">
											<div class="row">
												<div class="col-12">
													<div class="form-group">
														<div style="background: #ecb182; border-radius: 16px; padding: 12px 18px; display: inline-block; max-width: 100%; margin-bottom: 8px; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06)">
															<label for="">{{ notes_qc[0]?.creation_date | utcToLocal : "mediumDate" }} {{ notes_qc[0]?.creation_date | utcToLocal : "shortTime" }} - {{ notes_qc[0]?.agent }}</label>
															<br />
															{{ notes_qc[0]?.note }}
														</div>
													</div>
												</div>
											</div>
											<p class="text-pointer" (click)="showMoreNotes = true" *ngIf="!showMoreNotes && notes_qc.length > 1">Show more notes...</p>
											<p class="text-pointer" (click)="showMoreNotes = false" *ngIf="showMoreNotes && notes_qc.length > 1">Show less notes...</p>

											<div class="row" *ngFor="let note of notes_qc; let i = index">
												<ng-container *ngIf="i > 0 && showMoreNotes">
													<div class="col-12">
														<div class="form-group">
															<div style="background: #ecb182; border-radius: 16px; padding: 12px 18px; display: inline-block; max-width: 100%; margin-bottom: 8px; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06)">
																<label for="">{{ note.creation_date | utcToLocal : "mediumDate" }} {{ note.creation_date | utcToLocal : "shortTime" }} - {{ note.agent }}</label>
																<br />
																{{ note.note }}
															</div>
														</div>
													</div>
												</ng-container>
											</div>
										</div>

										<div *ngIf="notes_qc.length == 0 || notes_qc == null || notes_qc == undefined">There is no notes</div>
									</div>
								</div>

								<div class="row mt-4">
									<div class="col-md-6 ml-auto mr-auto">
										<label class="call-sheet-title">Client Notes:</label>
										<textarea rows="2" cols="152" [(ngModel)]="lead.client_notes" class="form-control border-input textArea-blue" type="text"></textarea>
									</div>
									<div class="col-md-6 col-sm-6">
										<label class="call-sheet-title">Client feedback:</label>
										<div class="row">
											<div class="col-md-3" align="center">
												<i
													class="em"
													[ngClass]="{
														'badge-em-disappointed_relieved': lead.client_satisfaction == 1,
														'em-frowning': lead.client_satisfaction == 2,
														'em-neutral_face': lead.client_satisfaction == 3,
														'em-slightly_smiling_face': lead.client_satisfaction == 4,
														'em-heart_eyes': lead.client_satisfaction == 5,
														'em-no_mouth': lead.client_satisfaction == 0
													}"
													aria-role="presentation"
													aria-label="DISAPPOINTED BUT RELIEVED FACE"
													style="font-size: 35px"
												></i>
											</div>
											<div class="col-md-9">
												<textarea name="" id="" rows="2" class="form-control"></textarea>
											</div>
										</div>
									</div>
								</div>

								<div class="row mt-4">
									<div class="col-md-12" align="right">
										<button (click)="saveLead()" class="btn btn-primary">Save</button>
									</div>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="activeTab === 'history'">
							<div class="container">
								<div class="row">
									<div class="col-md-1"></div>
									<div class="col-md-10">
										<h3>History Changes</h3>

										<table class="table">
											<thead>
												<tr>
													<th>Modified by</th>
													<th>Date Time</th>
													<th>From Status</th>
													<th>To Status</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let change of leadsChanges">
													<td>{{ change.modified_by }}</td>
													<td>{{ change.change_date | utcToLocal : "short" }}</td>
													<td [ngSwitch]="change.before_status">
														<span *ngSwitchCase="'Unreviewed'" class="badge bg-primary">Unreviewed</span>
														<span *ngSwitchCase="'Approved'" class="badge bg-success">Approved</span>
														<span *ngSwitchCase="'Denied'" class="badge bg-danger">Denied</span>
														<span *ngSwitchCase="'Fix'" class="badge bg-warning">Fix</span>
														<span *ngSwitchCase="'Reschedule Request'" class="badge bg-dark">Reschedule Request</span>
														<span *ngSwitchCase="'Pending Reschedule'" class="badge bg-dark">Pending Reschedule</span>
														<span *ngSwitchCase="'Replacement Request'" class="badge bg-info">Replacement Request</span>
														<span *ngSwitchCase="'Pending Replacement'" class="badge bg-info">Pending Replacement</span>
														<span *ngSwitchCase="'Replaced'" class="badge bg-info">Replaced</span>
														<span *ngSwitchCase="'Denied Reschedule'" class="badge bg-danger">Denied Reschedule</span>
														<span *ngSwitchCase="'QC Calls'" class="badge bg-warning">QC Call</span>
														<span *ngSwitchCase="'Rescheduled'" class="badge bg-dark">Rescheduled - {{ change.res_from_date | utcToLocal : "short" }}</span>
													</td>
													<td [ngSwitch]="change.new_status">
														<span *ngSwitchCase="'Unreviewed'" class="badge bg-primary">Unreviewed</span>
														<span *ngSwitchCase="'Approved'" class="badge bg-success">Approved</span>
														<span *ngSwitchCase="'Denied'" class="badge bg-danger">Denied</span>
														<span *ngSwitchCase="'Fix'" class="badge bg-warning">Fix</span>
														<span *ngSwitchCase="'QC Calls'" class="badge bg-warning">QC Call</span>
														<span *ngSwitchCase="'Reschedule Request'" class="badge bg-dark">Reschedule Request</span>
														<span *ngSwitchCase="'Pending Reschedule'" class="badge bg-dark">Pending Reschedule</span>
														<span *ngSwitchCase="'Replacement Request'" class="badge bg-info">Replacement Request</span>
														<span *ngSwitchCase="'Pending Replacement'" class="badge bg-warning">Pending Replacement</span>
														<span *ngSwitchCase="'Replaced'" class="badge bg-info">Replaced by {{ change.replaced_by }}</span>
														<span *ngSwitchCase="'Rescheduled'" class="badge bg-dark">Rescheduled - {{ change.res_to_date | utcToLocal : "short" }}</span>
														<span *ngSwitchCase="'Denied Reschedule'" class="badge bg-danger">Denied Reschedule</span>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="col-md-1"></div>
								</div>
							</div>
						</ng-container>
						<ng-container *ngIf="activeTab === 'call_sheet'">
							<div *ngIf="camapignInfoLoading">
								<app-loading></app-loading>
							</div>

							<div *ngIf="!camapignInfoLoading && campaign_info" class="col-md-12 ml-auto mr-auto mb-3" style="margin-top: 20px">
								<ul role="tablist" class="nav nav-pills justify-content-start">
									<li class="nav-item">
										<span (click)="callSheetTab = 'bio'" [class.active]="callSheetTab === 'bio'" class="nav-link profile-tab-btn info-toggle" role="tab" aria-expanded="true"> Bio/Script </span>
									</li>
									<li class="nav-item">
										<span (click)="callSheetTab = 'details'" [class.active]="callSheetTab === 'details'" class="nav-link profile-tab-btn info-toggle" role="tab" aria-expanded="false"> Details </span>
									</li>
								</ul>
							</div>

							<ng-container *ngIf="!camapignInfoLoading && campaign_info && callSheetTab === 'bio'">
								<div class="col-md-12 ml-auto mr-auto">
									<div *ngIf="campaign_info.script" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Sample Script</label>
												<div class="value-txt">
													{{ campaign_info.script }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Who We Are</label>
												<div class="value-txt">
													{{ campaign_info.who_we_are }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">What We Do</label>
												<div class="value-txt">
													{{ campaign_info.what_we_do }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Why Us</label>
												<div class="value-txt">
													{{ campaign_info.why_us }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="!camapignInfoLoading && campaign_info && callSheetTab === 'details'">
								<div class="col-md-12 ml-auto mr-auto">
									<div *ngIf="campaign_info.notes" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Special Notes</label>
												<div class="value-txt text-danger">
													{{ campaign_info.notes }}
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="campaign_info.questions" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Qualifying Questions</label>
												<div class="value-txt text-danger">
													{{ campaign_info.questions }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div *ngIf="campaign_info.employee_size_min && campaign_info.employee_size_min > 0" class="col-md-3 col-sm-3">
											<div class="form-group">
												<label class="call-sheet-title">Employee Size Min</label>
												<div class="value-txt">
													{{ campaign_info.employee_size_min | number : ".0" }}
												</div>
											</div>
										</div>
										<div *ngIf="campaign_info.employee_size_max && campaign_info.employee_size_max > 0" class="col-md-3 col-sm-3">
											<div class="form-group">
												<label class="call-sheet-title">Employee Size Max</label>
												<div class="value-txt">
													{{ campaign_info.employee_size_max | number : ".0" }}
												</div>
											</div>
										</div>
										<div *ngIf="campaign_info.asset_size_min && campaign_info.asset_size_min > 0" class="col-md-3 col-sm-3">
											<div class="form-group">
												<label class="call-sheet-title">Plan Asset Size Min</label>
												<div class="value-txt">
													{{ campaign_info.asset_size_min | currency }}
												</div>
											</div>
										</div>
										<div *ngIf="campaign_info.asset_size_max && campaign_info.asset_size_max > 0" class="col-md-3 col-sm-3">
											<div class="form-group">
												<label class="call-sheet-title">Plan Asset Size Max</label>
												<div class="value-txt">
													{{ campaign_info.asset_size_max | currency }}
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="campaign_info.additional_calendar_url" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Additional Calendar</label>
												<div class="value-txt">
													<a class="text-danger" [href]="campaign_info.additional_calendar_url" target="_blank">
														{{ campaign_info.additional_calendar_url }}
													</a>
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="campaign_info.scheduling" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Scheduling</label>
												<div class="value-txt text-danger">
													{{ campaign_info.scheduling }}
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="campaign_info.zip_codes_to_include === '1'" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Acceptable Zip Codes</label>
												<ul role="tablist" class="nav nav-pills justify-content-start">
													<li class="nav-item">
														<span (click)="showZipCodes = false" [class.active]="!showZipCodes" class="nav-link profile-tab-btn show-toggle" role="tab" aria-expanded="true" aria-="false" aria-controls="ngb-tab-5-panel"> Hide </span>
													</li>
													<li class="nav-item">
														<span (click)="showZipCodes = true" [class.active]="showZipCodes" class="nav-link profile-tab-btn show-toggle" role="tab" aria-expanded="false" aria-="false"> Show </span>
													</li>
												</ul>
												<div *ngIf="showZipCodes" class="value-txt">
													{{ campaign_info.zip_codes }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6 col-sm-6">
											<div class="form-group">
												<label class="call-sheet-title">Who's Attending the Meetings?</label>
												<div class="value-txt">
													{{ campaign_info.attending }}
												</div>
											</div>
										</div>
										<div class="col-md-6 col-sm-6">
											<div class="form-group">
												<label class="call-sheet-title">Type of Meeting</label>
												<div class="value-txt">
													{{ campaign_info.type }}
												</div>
											</div>
										</div>
									</div>
									<br />
								</div>
							</ng-container>
						</ng-container>
						<ng-container *ngIf="activeTab === 'attachments'">
							<div class="container">
								<div class="row">
									<div class="col-12">
										<h3>Attachments for premium Clients</h3>
										<div class="btn-group mr-2" role="group" aria-label="First group">
											<button
												type="button"
												class="btn btn-secondary btn-sm"
												[ngClass]="{
													'btn-outline-secondary': showing == 'URLs',
													'btn-secondary': showing == 'Files'
												}"
												(click)="showUploadFiles()"
											>
												Upload Files
											</button>
											<button
												type="button"
												class="btn btn-secondary btn-sm"
												[ngClass]="{
													'btn-outline-secondary': showing == 'Files',
													'btn-secondary': showing == 'URLs'
												}"
												(click)="showURLs()"
											>
												URLs
											</button>
										</div>
									</div>
								</div>

								<div class="row" style="position: relative">
									<div class="loading" *ngIf="loading">
										<div class="spinner-border text-primary" role="status">
											<span class="sr-only">Loading...</span>
										</div>
									</div>
									<div class="col-4" align="left">
										<div *ngIf="!uploading && showing == 'Files'" (dragleave)="onDragLeave($event)" (dragover)="onDragOver($event)" class="dropzone" appDnd (fileDropped)="onFileDropped($event)">
											<div>
												<input class="upload" type="file" #fileDropRef id="fileDropRef" multiple (change)="onFileDropped($event.target.files)" />
												<h3 class="upload">Drag and drop files here</h3>
												<h3 class="upload">or</h3>
												<button type="button" class="upload btn btn-secondary waves-effect waves-light">Browse for file</button>
											</div>
										</div>
									</div>

									<div class="col-8">
										<table class="table table-sm">
											<thead>
												<tr>
													<th>#</th>
													<th>File Name</th>
													<th>Upload Date</th>
													<th>Download</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let upFile of uploadedFiles; let i = index">
													<td>{{ i + 1 }}</td>
													<td>{{ upFile.name }}</td>
													<td>{{ upFile.upload_date | utcToLocal : "medium" }}</td>
													<td *ngIf="upFile.audio_url === 'NO_AUDIO'">
														<button class="btn btn-primary btn-sm" (click)="downloadFile(upFile.name)">Download</button>
													</td>
													<td *ngIf="upFile.audio_url != 'NO_AUDIO'">
														<a class="btn btn-primary btn-sm" href="{{ upFile.audio_url }}" target="_blank">Go to Url</a>
													</td>
													<td>
														<button class="btn btn-danger waves-effect waves-light btn-sm" (click)="deleteFile(upFile.id, upFile.name)">
															<i class="ri-delete-bin-line"></i>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</ng-container>

						<ng-container *ngIf="activeTab === 'client_attachments'">
							<div class="container" *ngIf="user.isPremium != '1'" align="center">
								<div class="row">
									<div class="col-12">
										<h1>This area is just for premium users</h1>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<img src="assets/img/premium.png" alt="" height="300px" />
									</div>
								</div>
							</div>
							<div class="container" *ngIf="user.isPremium === '1'">
								<div class="row">
									<div class="col-12">
										<h3>This lead has a recording.</h3>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<table class="table table-sm">
											<thead>
												<tr>
													<th>#</th>
													<th>Name</th>
													<th>Type</th>
													<th>Upload Date</th>
													<th>Action</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let upFile of uploadedFiles; let i = index">
													<td>{{ i + 1 }}</td>
													<td>{{ upFile.name }}</td>
													<td *ngIf="upFile.audio_url === 'NO_AUDIO'">File</td>
													<td *ngIf="upFile.audio_url != 'NO_AUDIO'">URL</td>
													<td>{{ upFile.upload_date | utcToLocal : "medium" }}</td>
													<td *ngIf="upFile.audio_url === 'NO_AUDIO'">
														<button class="btn btn-primary btn-sm" (click)="downloadFile(upFile.name)">Download</button>
													</td>

													<td *ngIf="upFile.audio_url != 'NO_AUDIO'">
														<a class="btn btn-primary btn-sm" href="{{ upFile.audio_url }}" target="_blank">Go to Url</a>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-------------------------------------------------------------------
	--------------------------------------------------------------------
	--------------------------------------------------------------------
	 -------------------------------- MODALS ----------------------------
	 --------------------------------------------------------------------
	 --------------------------------------------------------------------
	 -------------------------------------------------------------------- -->

	<ng-template #adminRescheduleModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title">Reschedule Lead</h4>
			<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<div class="form-group">
				<div class="row">
					<div class="col-6">
						<label for="">Select reschedule date:</label>
						<div class="input-group select-date">
							<input [(ngModel)]="reschedule.new_date" class="form-control" placeholder="yyyy-mm-dd" name="dp" ngbDatepicker #dp="ngbDatepicker" />
							<div class="input-group-append">
								<button class="btn btn-secondary" (click)="dp.toggle()" type="button">
									<i class="ri-calendar-line"></i>
								</button>
							</div>
						</div>
					</div>

					<div class="col-6" align="right">
						<ngb-timepicker style="position: relative; top: -10px" [(ngModel)]="newTime" [meridian]="true"></ngb-timepicker>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div class="form-check form-switch">
				<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck1" [(ngModel)]="reschedule.send_notification" />
				<label class="form-check-label" for="SwitchCheck1">Send email to customer</label>
			</div>
			<button type="button" class="btn btn-primary save-btn" (click)="askRescheduleLeadAdmin()">Ask reschedule admin</button>
		</div>
	</ng-template>

	<ng-template #replaceModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title">Replacement lead</h4>
			<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<p align="center" style="font-size: 12px">Select what lead is replacing this lead.</p>
			<div class="form-group">
				<div class="col-md-12 col-sm-12">
					<label for="">Replace by:</label>
					<div class="input-group mb-3">
						<div class="input-group-prepend">
							<label class="input-group-text" for="inputGroupSelect01" style="margin-bottom: 0px !important"><i class="ri-arrow-left-right-line"></i></label>
						</div>
						<select [(ngModel)]="lead.replaced_by" class="custom-select" id="inputGroupSelect01">
							<option *ngFor="let lead of posibleReplaceLeads" value="{{ lead.id }} - {{ lead.company_name }}">{{ lead.id }} - {{ lead.company_name }}</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer" style="display: block !important">
			<div class="row" style="margin-top: 10px; margin-bottom: 10px; padding-right: 15px">
				<div class="col-4" align="left">
					<button class="btn btn-secondary btn-sm" *ngIf="lead.replaced_by != ''" style="margin-left: 20px" (click)="unreplaceLead(lead)">Unreplace</button>
				</div>
				<div class="col-8" align="right">
					<button type="button" class="btn btn-danger btn-sm" (click)="modal.close('Save click')">Cancel</button>
					<button type="button" class="btn btn-primary btn-sm" (click)="replaceLeadBy(lead)">Replace</button>
				</div>
			</div>
		</div>
	</ng-template>

	<ng-template #modal_notes let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title">Notes of this lead</h4>
			<p>You can write your own notes to watch it later</p>
			<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<div class="form-group">
				<div class="row">
					<div class="col-12">
						<textarea [(ngModel)]="lead.write_client_notes" name="lead_client_comments" class="form-control" id="" cols="30" rows="10" placeholder="Write your notes..."></textarea>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<br />
			<button type="button" class="btn btn-success" (click)="writeClientNotes()" style="margin-bottom: 15px; margin-top: 15px; margin-right: 10px">Save Comments</button>
			<br />
		</div>
	</ng-template>

	<script *ngIf="activeTab === 'qc_notes'">
		var vid = document.getElementById("video");
		vid.addEventListener("loadedmetadata", getDuration, false);

		function getDuration() {
			console.info(vid.duration);
		}
	</script>

	<!-- Lifecycle lateral panel -->
	<div class="col-lg-3" *ngIf="!leadLoading && lead && activityPanelOpen">
		<div class="card h-100">
			<div class="card-body p-3">
				<h6 class="card-title mb-3" style="font-weight: 700; color: #2e353b;">
					<i class="ri-time-line me-1"></i> Activity
				</h6>
				<lead-details [leadId]="leadId"></lead-details>
			</div>
		</div>
	</div>

</div>
